<template lang="pug">
  .h-100
    app-header(title='LOGIN', :progressCurrent="slideIndex", :progressMax="slideCount", noBack)
    transition(name="down", mode="out-in")
      div.wizard-body.h-100.bg-alt(v-if='showWizard')
        .container.h-100.pt-4
          b-carousel.h-100(id="carouselWizard", ref='carouselWizard', :no-touch="true", :interval="0", v-model="slideIndex")
            b-carousel-slide
              template(v-slot:img="")
                // h4 CUSTOMER LOGIN
                b-form.mt-3(v-on:submit.prevent='onSubmit()')
                  b-container
                    b-form-group(label="EMAIL")
                      b-form-input.form-control(type='text', required, v-model='inputForm.email', name='email', autocomplete="email")
                    b-form-group(label="PASSWORD")
                      b-form-input.form-control(type='password', required, v-model='inputForm.password', name='password', autocomplete="password")
                    div.my-3.text-right
                      a(@click="showResetForm = !showResetForm") FORGOT PASSWORD?
                      b-collapse(v-model="showResetForm")
                        b-form(@submit.prevent="requestResetPassword()")
                          .row
                            .col-md-8
                              b-form-input(type="email", required, placeholder="Enter account email", v-model='resetForm.email')
                            .col-md-4
                              button-load(type="submit", :flag="alert.busy", label="RESET", classes="")
                    p.d-inline#testP Not registered yet?
                    b-link.m-0.text-muted.ml-2(:to="{ name: 'register' }")
                      span.mr-2 SIGN UP NOW
                      //- b-badge launching soon
                    br
                    br
                    p.d-inline Artists, please login at the
                    a.m-0.text-theme.ml-2(href="https://artist.wallcollective.co") ARTIST PORTAL
                    b-button(type='submit', v-show="false", ref='submit0')
                //- h4 ARTIST LOGIN
                //- p.d-inline Please use the
                //- b-link.m-0.text-theme.ml-2(:to="{ name: 'register' }") ARTIST PORTAL
            b-carousel-slide
              template(v-slot:img="")
                .container.pt-5.text-center
                  div.text-center
                    img.logo.mb-5(src="@/assets/images/branding/logo_dark.svg", alt="Wall collective logo")
                  b-spinner(type="grow")
    b-button#btn-bar.mt-2(type='submit', :disabled="slideIndex == 1", @click="$refs[`submit${slideIndex}`].click()")
      span LOGIN
</template>

<script>

// import Vue from 'vue';
import { mapActions } from 'vuex';
import standardMix from '@/mixins/standardMix';
import { userService } from '@/services';

export default {
  name: 'LoginPage',
  components: {
  },
  mixins: [standardMix],
  data() {
    return {
      showWizard: false,
      showResetForm: false,
      slideIndex: 0,
      slideCount: 1,
      inputForm: {
        email: '',
        password: '',
      },
      resetForm: {
        email: '',
      },
    };
  },
  computed: {
  },
  methods: {
    ...mapActions('account', ['login', 'logout']),
    async onSubmit() {
      this.$refs.carouselWizard.next();
      try {
        this.busy();
        // (optional) Wait until recaptcha has been loaded.
        // await this.$recaptchaLoaded();
        // Execute reCAPTCHA with action "login".
        // const token = await this.$recaptcha('login');
        // const token = 'myth';
        // this.$gtm.trackEvent({
        //   event: null, // Event type [default = 'interaction'] (Optional)
        //   category: 'Page Clicks',
        //   action: 'Click',
        //   label: 'btnSubmitOrder',
        //   noninteraction: false, // Optional
        // });
        await this.login({ email: this.inputForm.email, password: this.inputForm.password, role: 'customer' });
        this.slideIndex = 0;
      } catch (error) {
        this.error(error);
      }
    },
    async requestResetPassword() {
      try {
        this.busy();
        await userService.requestResetPassword(this.resetForm);
        this.success('Reset link sent');
        this.resetForm.email = '';
        this.showResetForm = false;
      } catch (error) {
        this.error(error);
      }
    },
  },
  created() {
    // Reset carousel
    this.slideIndex = 0;
    // Pre-populate values here
  },
  mounted() {
    // Create animation effect
    setTimeout(() => { this.showWizard = true; }, 100);
  },
};
</script>

<style lang="scss" scoped>
.wizard-body {
  z-index: 100;
  background-color: white;
}

  .carousel-indicators > li {
    background-color: blue !important;
  }

  .down-enter-active, .page-leave-active {
    transition: transform 0.5s;
  }
  .down-enter {
    transform: translateY(100%);
  }
  .logo {
    width: 200px;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/Login.vue